export default __webpack_public_path__ + "static/media/userf-2.799dbef0.jpg";